
export const AuthAMPA = ({ auth, handleChange, error }) => {
  return (<>
    <div className="row">
    <div className="col col-12 ">
      <h4>
      Autorització cessió del correu electrònic a l’AMPA
      </h4>
      <p>
        <input type="checkbox" id="authAMPA" name="authAMPA" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
        <label htmlFor="authAMPA"> AUTORITZO que el centre faliciti el meu correu electrònic a l’AMPA per poder rebre informació </label>
        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
      </p>

    </div>
  </div>

    <br />
  </>)
}
